import { vendors } from "../../../data/vendors";
import Summerybox from "../../../components/Summerybox";
import PageHeading from "../../../components/PageHeading";
// import Sidebar from "../../../components/Sidebar";
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";

const Overview = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const filteredVendors = vendors.filter((vendor) =>
    vendor.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      {/* <Navbar /> */}

      <div className="d-flex">
        {/* <Sidebar /> */}

        <div className="flex-grow-1">
          <div className="container-fluid p-4">
            <div className="shadow bg-white rounded p-4 mb-4">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <PageHeading pagename="Vendor Overview" />
                <button className="btn btn-primary">+ Add Vendor</button>
              </div>

              <div className="d-flex flex-wrap gap-3 justify-content-between">
                <Summerybox
                  color="#006CFF"
                  title="No. of Vendors"
                  number={vendors.length}
                />
                <Summerybox
                  color="#03D4C6"
                  title="Task In Progress"
                  number={vendors.reduce(
                    (sum, v) => sum + v.tasks.inProgress,
                    0
                  )}
                />
                <Summerybox
                  color="#FE996C"
                  title="Paid Amount"
                  money={vendors.reduce(
                    (sum, v) => sum + v.paidAmount,
                    0
                  )}
                />
                <Summerybox
                  color="#8B5CF6"
                  title="Remaining Amount"
                  money={vendors.reduce(
                    (sum, v) => sum + v.remainingAmount,
                    0
                  )}
                />
              </div>
            </div>

            {/* TABLE */}
            <div className="pt-4">
          
              <div className="d-flex justify-content-between align-items-center mb-4">
                <PageHeading pagename="Vendor List" />
                <input
                  type="text"
                  className="form-control ms-auto"
                  placeholder="Search Vendor"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ width: "300px" }}
                />
              </div>

              <table className="table">
                <thead>
                  <tr className="table-head">
                    <th>Name</th>
                    <th>Paid Up Capital</th>
                    <th>Remaining Amount</th>
                    <th>Tasks Status</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredVendors.map((vendor) => (
                    <tr
                      key={vendor.id}
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        navigate(
                          `/vendoroverview/vendordetail/${vendor.id}`
                        )
                      }
                    >
                      <td>{vendor.name}</td>
                      <td>₹ {vendor.paidAmount}</td>
                      <td>₹ {vendor.remainingAmount}</td>
                      <td>
                        <span className="text-success fw-bold">
                          {vendor.tasks.completed} ↑
                        </span>
                        <span className="text-danger fw-bold ms-3">
                          {vendor.tasks.inProgress} ↓
                        </span>
                        <span className="text-secondary fw-bold ms-3">
                          {vendor.tasks.remaining}
                        </span>
                        {/* <i
                          className="bi bi-info-circle ms-3"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            if (vendor.id) {
                              navigate(`/statustask/${vendor.id}`);
                            } else {
                              console.error("Vendor ID is undefined:", vendor);
                            }
                          }}
                        ></i> */}
                        <button className="btn p-0 m-0 align-baseline">
                          <i
                            className="bi bi-info-circle ms-3"
                            style={{ cursor: "pointer", fontSize: "1.2rem" }} 
                            onClick={(e) => {
                              e.stopPropagation();  
                              if (vendor.id) {
                                navigate(`/statustask/${vendor.id}`);
                              } else {
                                console.error("Vendor ID is undefined:", vendor);
                              }
                            }}
                          ></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Overview;
